// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/meditation-categories`;

export const GetMeditationCatListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getall"}),
    });
    // console.log("Response from API:", response);

    if (!response.ok) throw new Error("Failed to fetch recipe list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteMeditationCat = async (catId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Category ?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", data:{_id: catId} }),
      });

      const data = await response.json();
      if (data.success) toast.success("Category deleted successfully");
      else toast.warning("Category deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitMeditationCatApi = async (catData) => {
  const actionType = catData._id ? "edit" : "add";

  const payload = {
    action: actionType,
    data: {
      name: catData.name,
    },
  };

  if (catData._id) {
    payload.data._id = catData._id;
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.success || response.status === 200 || response.status === 201) {
      toast.success(catData._id ? "Category updated successfully" : "Category added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save Category");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the question");
    return null;
  }
};
export const getMeditationCatByIdApi = async (id) => {
  try {
    const payload = {
      action: "getById",
      data: { _id: id }
    }
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load recipe");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
